import React from "react";

import "./editcategoryform.css";
const EditCategoryForm = (props) => {
  return (
    <div className="editd_person_details_formpage">
      <div className="container main_section">
        <div className="topheader">
          <ul>
            <li>
              <i
                className="fa fa-arrow-circle-o-right fa-2x"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              <h5>{props.category.collectionName}</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-8 first_section">
            <form onSubmit={props.handleSubmit}>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editCategoryName">Name</label>
                  <input
                    name="name"
                    type="text"
                    className="form-control"
                    id="editCategoryName"
                    required
                    value={props.category.name}
                    onChange={props.onEdit}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editCategorySlug">Category ID (slug)</label>
                  <input
                    name="categoryId"
                    type="text"
                    className="form-control"
                    id="editCategorySlug"
                    value={props.category.categoryId || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <div className="form-check">
                    <input
                      name="isActive"
                      type="checkbox"
                      className="form-check-input"
                      id="isActive"
                      checked={props.category.isActive !== false}
                      onChange={props.onEdit}
                    />
                    <label className="form-check-label" htmlFor="isActive">
                      Active
                    </label>
                  </div>
                </div>
              </div>

              <button className="btn btn-success update_btn" type="submit">
                Update
              </button>
            </form>
          </div>
          <div className="col-sm-4 second_section">
            <div className="profileimage">{props.profileHtmlelEment}</div>
            <div className="btn_section">
              <label htmlFor="categoryImageUpload" className="selectimage">
                Upload Image
              </label>
              <input
                name="avatarimage"
                id="categoryImageUpload"
                type="file"
                onChange={props.onImageChange}
              />
              <button
                type="button"
                className="removebutton"
                onClick={props.onImageRemove}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategoryForm;
